import { createAction, props } from '@ngrx/store';
import { ApiConstants } from 'src/app/base/api-constants';

const GET_APPS = '[Apps] Get Apps';
const GET_ALL_APPS = '[Apps] Get All Apps';
const SAVE_APPS = '[Apps] Save Apps';
const SENT_APPS = '[Apps] Sent Apps';
const SET_APPS = '[Apps] Set Apps';
const SET_ALL_APPS = '[Apps] Set All Apps';
const SET_DROP_APPS = '[Apps] Set Apps for Dropdown';
const SET_APP_ID = '[Apps] Set App Id';
const UPDATE_APPS = '[Apps] Update Apps';
const SENT_UPDATE_APPS = '[Apps] Sent Update Apps';
const GET_ORGS = '[Apps] Get Orgs';
const DELETE_APPS = '[Apps] Delete Apps';
const DELETE_APPS_SUCCESS = '[Apps] Delete Apps Success';
const SENT_DELETE_APPS = '[Apps] Sent Delete App';
const GET_APP_BY_ID = '[Apps] Get App By Id';
const SET_APP_BY_ID = '[Apps] Set App By Id';
const NEW_APP_CREATED = '[Apps] Newly Created App';
const GET_SID_BASED_APP = '[Apps] Get SID Based App';
const SET_SID_BASED_APP = '[Apps] Set SID Based App';
const GET_APPS_BASED_SEARCH = '[Apps] Get APPs Based on Search';
const TRIGGER_APP_GENERATION = '[Apps] Trigger App Generation';
const RESET_SEARCH = '[Apps] Get APP Based Search';
const ERROR_MESSAGE = '[Apps] Error Message Apps';
const GET_GENERATED_URL = '[Apps] Get Generated Url';
const SET_GENERATED_URL = '[Apps] Set Generated Url';
const GET_APPS_FOR_ORG = '[Apps] Get Apps For Org';
const GET_APPS_FOR_ORG_SORTING = '[Apps] Get Apps For Org Sorting';
const GET_GEN_STATUS = '[Apps] Get gen App Status';
const SET_GENERATION_STATUS = '[Apps] Set gen App Status';
const SAVE_USER_TO_APP = '[Apps] Save User To App';
const GET_USER_FRM_APP = '[Apps] Get Users To App';
const SET_USER_FRM_APP = '[Apps] Set Users To App';
const DELETE_USER_FRM_APP = '[Apps] Delete Users From App';
const SAVE_USER_APP_STAS = '[Apps] Save User To App Status';
const LAST_PUBLISH = '[CodeGeneration] Last Publish';
const LAST_PUBLISH_DATA = '[CodeGeneration] Last Publish Data';
const SET_META_INFO = '[Meta Data] Application Meta Info';
const SET_FS_LOGIN = '[FS Login] FS Login';
const SAVE_APP_SUITE = '[Apps] Save App Suite';
const GET_INDEPENDENT_APPS = '[Apps] Get Indepent Apps';
const SET_INDEPENDENT_APPS = '[Apps] Set Indepent Apps';
const GET_DB_LIST = '[Apps] Get DB Lists';
const SET_DB_LIST = '[Apps] Set DB Lists';
const GET_MEM_LIST = '[Apps] Get Member lists';
const SET_MEM_LIST = '[Apps] Set Member lists';
const GET_MEM_DB_LIST = '[Apps] Get Member lists for Member App';
const SET_MEM_DB_LIST = '[Apps] Set Member lists for Member App';
const GET_MEM_TECHNOLOGY_STACK = '[TechnologyStack] Get Mem App technology choice';
const SET_MEM_TECHNOLOGY_STACK = '[TechnologyStack] Set Mem App technology choice';
const GET_FULL_APPS = '[Apps] Get Full Apps';
const GET_APPS_SUITE_LIST = '[Apps] Get app list from suite';
const SET_APPS_SUITE_LIST = '[Apps] Set app list from suite';
const SET_CURRENT_APP_FULL_DATA = '[Apps] Set Current App Full Data';

const getAllApps = createAction(GET_ALL_APPS, props<{ getAppsApiConstants: any; orgId: string }>());

const getFullApps = createAction(GET_FULL_APPS, props<{ apiConstants: any }>());

const getApps = createAction(GET_APPS, props<{ getAppsApiConstants: any; orgId: string; filter: any }>());

const getAppsForOrg = createAction(
  GET_APPS_FOR_ORG,
  props<{ getAppsApiConstants: any; filter: any; orgChange?: any }>()
);

const getAppsForOrgWithSorting = createAction(
  GET_APPS_FOR_ORG_SORTING,
  props<{ getAppsApiConstants: any; filter: any }>()
);

const setAllApps = createAction(SET_ALL_APPS, props<{ allAppList: any; totalRecords: any }>());
const setAppsDrop = createAction(SET_DROP_APPS, props<{ appDropList: any }>());
const setApps = createAction(SET_APPS, props<{ appList: any }>());
const setAppId = createAction(SET_APP_ID, props<{ appId: string }>());
const sentApps = createAction(SENT_APPS, props<{ getAppsApiConstants: any; saveAppsData }>());
const saveApps = createAction(SAVE_APPS, props<{ appsData: any }>());
const sentUpdateApps = createAction(SENT_UPDATE_APPS, props<{ getAppsApiConstants: any; updateAppsData }>());
const getOrgs = createAction(GET_ORGS, props<{ getOrgConstants: any }>());
const getAppById = createAction(GET_APP_BY_ID, props<{ getAppsApiConstants: any; appId: string }>());
const deleteAppsSuccess = createAction(DELETE_APPS_SUCCESS, props<{ success: boolean }>());
const setAppById = createAction(SET_APP_BY_ID, props<{ appData: any }>());
const updateApps = createAction(UPDATE_APPS, props<{ updateAppsData: any }>());
const sentDeleteApps = createAction(
  SENT_DELETE_APPS,
  props<{ getAppsApiConstants: any; appId: string; appName: string; toDeleteInGit?: boolean }>()
);

const deleteApps = createAction(DELETE_APPS, props<{ appId: string }>());

const newAppCreated = createAction(NEW_APP_CREATED, props<{ createdApp: any }>());

const getSidBasedApps = createAction(
  GET_SID_BASED_APP,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);
const setSidBasedApps = createAction(
  SET_SID_BASED_APP,
  props<{
    sidAppData: any;
  }>()
);

const setCurrentAppFullData = createAction(
  SET_CURRENT_APP_FULL_DATA,
  props<{
    currentAppFullData: any;
  }>()
);

const getAppsBasedOnSearch = createAction(
  GET_APPS_BASED_SEARCH,
  props<{ apiConstants: any; start: any; length: any; searchFields: any }>()
);

const triggerPrototypingAppGeneration = createAction(
  TRIGGER_APP_GENERATION,
  props<{ genAppApi: any; genParams: any }>()
);
const resetSearch = createAction(RESET_SEARCH, props<{ searchText: string }>());
const getErrorMessage = createAction(ERROR_MESSAGE, props<{ errorMessage: any }>());
const getGeneratedAppUrl = createAction(
  GET_GENERATED_URL,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);

const setGeneratedAppUrl = createAction(SET_GENERATED_URL, props<{ genUrl: any }>());
const getGenerationStatus = createAction(GET_GEN_STATUS, props<{ genStatusApi: any }>());
const setGenStatus = createAction(SET_GENERATION_STATUS, props<{ genStatus: any }>());
const getLastPublish = createAction(LAST_PUBLISH, props<{ lastPublishApi: any }>());

const setLastPublish = createAction(LAST_PUBLISH_DATA, props<{ publishLog: any }>());
const saveUserToApp = createAction(SAVE_USER_TO_APP, props<{ saveApiConstants; params: any }>());
const getUsersFromApp = createAction(GET_USER_FRM_APP, props<{ apiConstants: any }>());
const setUsersFromApp = createAction(SET_USER_FRM_APP, props<{ usersBasedOnApp: any }>());
const deleteUsersFromApp = createAction(DELETE_USER_FRM_APP, props<{ deleteApiConstants; params }>());
const saveUserToAppStas = createAction(SAVE_USER_APP_STAS, props<{ userSaveStatus }>());
const setAppMetaInfo = createAction(SET_META_INFO, props<{ metaInfo: any }>());
const setFsLoginInitiated = createAction(SET_FS_LOGIN, props<{ loggedIn: boolean }>());
const saveAppSuite = createAction(SAVE_APP_SUITE, props<{ saveApiConstants; appData }>());

const getIndepApps = createAction(GET_INDEPENDENT_APPS, props<{ apiConstants: any; filter: any }>());

const setIndepApps = createAction(SET_INDEPENDENT_APPS, props<{ indepApps: any }>());

const getDBlist = createAction(GET_DB_LIST, props<{ apiConstants: any; params: any }>());

const setDBlist = createAction(SET_DB_LIST, props<{ dbList: any }>());

const getMemApps = createAction(GET_MEM_LIST, props<{ apiConstants: any; params: any }>());

const setMemApps = createAction(SET_MEM_LIST, props<{ memAppList: any }>());

const getMemTechnologyStack = createAction(GET_MEM_TECHNOLOGY_STACK, props<{ apiConstants: any; appId: string }>());

const setMemTechnologyStack = createAction(SET_MEM_TECHNOLOGY_STACK, props<{ memtechnologyStackData: any }>());

const getMemDBlist = createAction(GET_MEM_DB_LIST, props<{ apiConstants: any; params: any }>());

const setMemDBlist = createAction(SET_MEM_DB_LIST, props<{ memdbList: any }>());

const getAllAppsFromSuite = createAction(GET_APPS_SUITE_LIST, props<{ apiConstants: any; params: any }>());

const setAllAppsFromSuite = createAction(SET_APPS_SUITE_LIST, props<{ allAppFromSuiteList: any }>());

const SET_GENERATION_STAGE = '[Apps] Set Generation Stage';
const setGenerationStage = createAction(SET_GENERATION_STAGE, props<{ stage: string }>());

export {
  setGenStatus,
  setGenerationStage,
  getAllApps,
  getApps,
  sentApps,
  setAppId,
  getOrgs,
  sentUpdateApps,
  getAppById,
  setAppById,
  sentDeleteApps,
  setAllApps,
  setApps,
  saveApps,
  updateApps,
  deleteApps,
  newAppCreated,
  deleteAppsSuccess,
  getSidBasedApps,
  setSidBasedApps,
  getAppsBasedOnSearch,
  triggerPrototypingAppGeneration,
  resetSearch,
  getErrorMessage,
  getGeneratedAppUrl,
  setGeneratedAppUrl,
  getAppsForOrg,
  getGenerationStatus,
  saveUserToApp,
  getUsersFromApp,
  setUsersFromApp,
  deleteUsersFromApp,
  saveUserToAppStas,
  getAppsForOrgWithSorting,
  setAppsDrop,
  getLastPublish,
  setLastPublish,
  setAppMetaInfo,
  setFsLoginInitiated,
  saveAppSuite,
  getIndepApps,
  setIndepApps,
  getDBlist,
  setDBlist,
  getMemApps,
  setMemApps,
  getMemTechnologyStack,
  setMemTechnologyStack,
  getMemDBlist,
  setMemDBlist,
  getFullApps,
  getAllAppsFromSuite,
  setAllAppsFromSuite,
  setCurrentAppFullData
};
